<template>
  <div>
    <h3>Weekly Announcements</h3><br>
    
    <div class="row">
      <div class="col-sm-1"/>
      <div class="col-sm-10">
        <announce-form/>
      </div>
      <div class="col-sm-1"/>
    </div>

    <div class="row">
      <div class="col-sm-2"/>
      <div class="col-sm-8">
          <announce-list/>
      </div>
      <div class="col-sm-2"/>
    </div>
    <hr>
  </div>
</template>

<script>
// @ is an alias to /src
import AnnounceForm from '@/components/AnnounceForm.vue'
import AnnounceList from '@/components/AnnounceList.vue'

export default {
  name: 'Announcements',
  components: { 
    'announce-form': AnnounceForm,
    'announce-list': AnnounceList
  },
}
</script>